import React from "react";
import { observer, inject } from "mobx-react";
import QuestionContainer from "./question";
import * as dateFns from "date-fns";
import SurveyViewWelcome from "./survey-view-welcome";

const SurveyView = props => {
  const { $survey, $user, $config, $router } = props.store;

  const mentor = $user.sessionUser.isMentor; //$router.getURLParameterByName("mentor");
  const group = $router.getURLParameterByName("group");

  const showForm = () => {
    if (mentor) return true;
    else if (!$survey.selected.enabled) return false;
    else if (group && $survey.selected.disabledForGroups.indexOf(group) > -1) return false;
    else return true;
  };

  const getMostRecentAnswerDate = answers => {
    return answers.map(a => a.createdOn).sort(dateFns.compareDesc);
  };

  return (
    $survey.selected && (
      <section className="border-radius-large container">
        {$user.sessionUser.responses.length > 0 && (
          <div>
            <div className="bg-orange p-4 border-radius color-white mb-4">
              {`Deze vragenlijst is laatst ingevuld op ${dateFns.format(
                getMostRecentAnswerDate($user.sessionUser.responses)[0],
                "dd/MM/yyyy"
              )}.`}

              {true === false && $survey.selected.interval_period !== "none" && (
                <span>
                  Opnieuw invullen mogelijk vanaf{" "}
                  {dateFns.format($survey.selected.expireDate, "dd/MM/yyyy")}.
                </span>
              )}

              {!$config.hide_show_results_after_submit && (
                <a className="block" href={`/survey/results/${$survey.selected._key}`}>
                  Bekijk resultaten
                </a>
              )}
            </div>
          </div>
        )}

        {showForm() ? (
          <React.Fragment>
            {$survey.selected._disableWelcome ? (
              <form name={"survey-" + $survey.selected._key}>
                <QuestionContainer {...props} survey={$survey.selected} mode="view" />
              </form>
            ) : (
              <SurveyViewWelcome survey={$survey.selected} />
            )}
          </React.Fragment>
        ) : (
          <div className="bg-orange p-4 border-radius color-white">
            {$survey.selected.disabledMessage}
          </div>
        )}
      </section>
    )
  );
};

export default inject("store")(observer(SurveyView));
